import apiClient from '../apiClient'

const getRecentCallSessions = async () => {
    try {
        const response = await apiClient.get('/admin/call-sessions/recent')
        return response.data
    } catch (error) {
        console.error(
            'Failed to retrieve recent call sessions: ' + error.message
        )
        throw error
    }
}

const getDecafPayouts = async (page = 1, limit = 10) => {
    try {
        const response = await apiClient.get('/admin/decaf-payouts/all', {
            params: { page, limit },
        })
        return response.data
    } catch (error) {
        console.error('Failed to retrieve Decaf payouts: ' + error.message)
        throw error
    }
}

const updatePayoutsStatus = async (paymentIds, status, reason = null) => {
    try {
        const payload = { paymentIds, status }
        if (reason) {
            payload.reason = reason
        }
        const response = await apiClient.post(
            '/admin/decaf-payouts/update-status',
            payload
        )
        return response.data
    } catch (error) {
        console.error('Failed to update payout statuses: ' + error.message)
        throw error
    }
}

const getCreators = async (params = {}) => {
    try {
        const response = await apiClient.get('/admin/users/creators', {
            params: {
                page: params.page || 1,
                limit: params.limit || 20,
                ...(params.status && { status: params.status }),
                ...(params.category && { category: params.category }),
                ...(params.listingStatus && {
                    listingStatus: params.listingStatus,
                }),
                ...(params.search && { search: params.search }),
                ...(params.sortBy && { sortBy: params.sortBy }),
                ...(params.sortOrder && { sortOrder: params.sortOrder }),
                ...(params.onlineStatus && { onlineStatus: params.onlineStatus }),
                ...(params.contentPermission !== undefined && {
                    contentPermission: params.contentPermission,
                }),
            },
        })
        return response.data
    } catch (error) {
        console.error('Failed to retrieve creators: ' + error.message)
        throw error
    }
}

const updateCreatorListingStatus = async (userId, status) => {
    try {
        const response = await apiClient.put(
            `/admin/listings/${userId}/status`,
            { status }
        )
        return response.data
    } catch (error) {
        console.error('Failed to update listing status: ' + error.message)
        throw error
    }
}

const getConversations = async (params = {}) => {
    try {
        const response = await apiClient.get('/admin/conversations', {
            params: {
                page: params.page || 1,
                limit: params.limit || 20,
                ...(params.sortBy && { sortBy: params.sortBy }),
                ...(params.sortOrder && { sortOrder: params.sortOrder }),
                ...(params.search && { search: params.search }),
                ...(params.creatorId && { creatorId: params.creatorId }),
                ...(params.clientId && { clientId: params.clientId }),
            },
        })
        return response.data
    } catch (error) {
        console.error('Failed to retrieve conversations: ' + error.message)
        throw error
    }
}

const getConversationMessages = async (conversationId) => {
    try {
        const response = await apiClient.get(
            `/admin/conversations/${conversationId}/messages`
        )
        return response.data
    } catch (error) {
        console.error('Failed to retrieve conversation messages: ' + error.message)
        throw error
    }
}

const searchUserByUsername = async (username, typeofuser = null) => {
    try {
        const params = { username }
        if (typeofuser) {
            params.typeofuser = typeofuser
        }
        const response = await apiClient.get('/admin/users/search', { params })
        return response.data
    } catch (error) {
        console.error('Failed to search user: ' + error.message)
        throw error
    }
}

const getClients = async (params = {}) => {
    try {
        const response = await apiClient.get('/admin/users/clients', {
            params: {
                page: params.page || 1,
                limit: params.limit || 20,
                ...(params.sortBy && { sortBy: params.sortBy }),
                ...(params.sortOrder && { sortOrder: params.sortOrder }),
                ...(params.search && { search: params.search }),
                ...(params.funnelState && { funnelState: params.funnelState }),
                ...(params.hasWallet && { hasWallet: params.hasWallet }),
                ...(params.ipBlocked && { ipBlocked: params.ipBlocked }),
            },
        })
        return response.data
    } catch (error) {
        console.error('Failed to retrieve clients: ' + error.message)
        throw error
    }
}

const getTransactions = async (params = {}) => {
    try {
        const response = await apiClient.get('/admin/transactions', {
            params: {
                page: params.page || 1,
                limit: params.limit || 20,
                ...(params.sortBy && { sortBy: params.sortBy }),
                ...(params.sortOrder && { sortOrder: params.sortOrder }),
                ...(params.type && { type: params.type }),
                ...(params.status && { status: params.status }),
                ...(params.clientId && { clientId: params.clientId }),
                ...(params.creatorId && { creatorId: params.creatorId }),
            },
        })
        return response.data
    } catch (error) {
        console.error('Failed to retrieve transactions: ' + error.message)
        throw error
    }
}

export default {
    getRecentCallSessions,
    getDecafPayouts,
    updatePayoutsStatus,
    getCreators,
    updateCreatorListingStatus,
    getConversations,
    getConversationMessages,
    searchUserByUsername,
    getClients,
    getTransactions,
}
